import { apiProxyRequest } from "Api/apiProxyRequest";

import type {
  Activity,
  GetProjectActivitiesRequestProps
} from "Api/activity/types";

export const getProjectActivitiesRequest = ({
  projectId,
  filters,
  state,
  startsAt,
  count
}: GetProjectActivitiesRequestProps) =>
  apiProxyRequest<Activity[]>(`/projects/${projectId}/activities`, "GET", {
    type: filters,
    state,
    starts_at: startsAt?.toISOString(),
    count
  });
